import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { AwsAuthService } from '@nx/auth';
import { expiredTimeKey } from '../../../../constants/idle-timer.constants';

import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';
import { SessionUpdatedService } from '../../../../services/session-updated.service';
import { TranslateService } from 'libs/mono-common/src/lib/services/translate.service';
@UntilDestroy()
@Component({
  selector: 'mono-common-header-user-links',
  templateUrl: './header-user-links.component.html',
  styleUrls: ['./header-user-links.component.scss']
})
export class HeaderUserLinksComponent implements OnInit {

  public userLoggedIn = false;
  private readonly defaultLanguage = "en";
  public userFullName: string;
  public currentRoute: string;

  @Input() language: string = this.defaultLanguage;
  @Input() signInLinkPath: string;
  @Input() registrationLinkPath: string;
  @Input() editMyDetailsLinkPath: string;

  constructor(
    private awsAuthService: AwsAuthService,
    private router: Router,
    private location: Location,
    private sessionUpdatedService: SessionUpdatedService,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    this.checkIfUserIsLoggedIn();
  }

  public logout() {
    this.awsAuthService.logout().then(() => {
      sessionStorage.removeItem(expiredTimeKey);
      this.router.navigateByUrl('/').then(() => {
        window.location.reload();
      });
    })
  }

  public translate(template: string) {
    return this.translateService.translate(template, this.language);
  }

  private getCurrentRoute() {
    this.currentRoute = this.location.path();
    this.router.events.subscribe(() => {
      this.currentRoute = this.location.path();
    });
  }

  private checkIfUserIsLoggedIn() {
    this.awsAuthService.isUserLoggedIn().then((user) => {
      if (user) {
        this.getUserDetails();
      }
      this.userLoggedIn = user;
      this.getCurrentRoute();
    })
  }

  private getUserDetails() {
    this.awsAuthService.getCurrentUserClaims().then((user) => {
      if (user) {
        this.userFullName = user.user.apps.lmw.fullName;
      }
    });

    this.sessionUpdatedService.getSessionUpdatedAnnouncer().pipe(untilDestroyed(this)).subscribe((userClaims) => {
      if(userClaims?.user?.apps?.lmw?.fullName) {
        this.userFullName = userClaims.user.apps.lmw.fullName;
      }
    })
  }
}
